<template>
  <div class="flex min-h-70vh items-center justify-center">
    <div class="text-center">
      <h1 class="text-2xl font-bold mb-4">Something Went Wrong</h1>
      <p class="mb-4">We encountered an error while processing your request.</p>
      <NuxtLink to="/" class="text-blue-600 hover:underline">
        Return to Home
      </NuxtLink>
    </div>
  </div>
</template> 